import { useState } from "react";
import { LuWheat, LuMilk, LuEgg, LuFish, LuNut, LuBean, LuSprout, LuLeaf, LuShell, LuFlower2, LuWine, LuCircleAlert } from "react-icons/lu";

const Shrimp = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M18 8c-1-4-7-5-11-2-4 3-3 9 1 11 3 2 7 1 9-2l-4-2-2 3M18 8l3-4M18 8l4-1M17 10l3 2-3 3M6 8l4 3M5 12l5 1"/><path d="M14 7h.01"/></svg>;
const Sesame = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" aria-hidden="true"><ellipse cx="7" cy="8" rx="2.3" ry="4" transform="rotate(-25 7 8)"/><ellipse cx="16" cy="8" rx="2.3" ry="4" transform="rotate(25 16 8)"/><ellipse cx="12" cy="17" rx="2.3" ry="4" transform="rotate(60 12 17)"/></svg>;
const Peanuts = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" aria-hidden="true"><path d="M10 4C5 2 2 8 6 11c2 2 1 3 2 6 2 6 10 4 10-1 0-3-3-4-3-6 0-4-2-6-5-6Z"/><path d="m7 7 4 1m-2 3 4 1m-2 3 4 1m-3 3 3-1"/></svg>;
const definitions = {
  celery: ["Apio", LuLeaf], crustaceans: ["Crustáceos", Shrimp], eggs: ["Huevos", LuEgg], fish: ["Pescado", LuFish],
  gluten: ["Gluten", LuWheat], lactose: ["Lactosa", LuMilk], lupin: ["Altramuces", LuSprout], molluscs: ["Moluscos", LuShell],
  mustard: ["Mostaza", LuFlower2], nuts: ["Frutos secos", LuNut], peanuts: ["Cacahuetes", Peanuts], sesame: ["Sésamo", Sesame], soy: ["Soja", LuBean], sulfites: ["Sulfitos", LuWine],
};
export const normalizeProductAllergens = input => {
  let value = input;
  try {
    // JSON columns may arrive serialized, including inside the allergens wrapper.
    for(let depth=0; depth<4; depth++) {
      if(typeof value === 'string') { value=JSON.parse(value); continue; }
      if(value && typeof value === 'object' && !Array.isArray(value) && Object.prototype.hasOwnProperty.call(value,'allergens')) { value=value.allergens; continue; }
      break;
    }
  } catch { return {entries:[],invalid:true}; }
  if(value == null) return {entries:[],invalid:false};
  if(typeof value !== 'object' || Array.isArray(value)) return {entries:[],invalid:true};
  const entries=[]; let invalid=false;
  for(const [key, present] of Object.entries(value)) {
    if(/^\d+$/.test(key)) {invalid=true;continue;}
    if(present === true || present === 1 || present === 'true' || present === '1') entries.push([key,true]);
    else if(![false,0,'false','0',null].includes(present)) invalid=true;
  }
  return {entries,invalid};
};

export const ProductAllergens = ({ allergens }) => {
  const [active, setActive] = useState(null);
  const {entries,invalid} = normalizeProductAllergens(allergens);
  if (!entries.length && !invalid) return null;
  return <section className="eats-product-allergens" aria-label="Alérgenos">
    <span>Alérgenos</span>
    {invalid && <p role="alert">No se puede confirmar la información de alérgenos. Consulta al establecimiento.</p>}
    <div className="eats-allergen-icons">
      {entries.map(([key]) => {
        const [name, Icon] = definitions[key] || [key, LuCircleAlert];
        return <button type="button" key={key} aria-label={`Alérgeno: ${name}`} aria-expanded={active === key} title={name}
          onClick={() => setActive(value => value === key ? null : key)}
          onKeyDown={event => { if (event.key === "Escape" && active) { event.preventDefault(); event.stopPropagation(); setActive(null); } }}>
          <Icon aria-hidden="true" />
          {active === key && <span className="eats-allergen-tooltip" role="status">{name}</span>}
        </button>;
      })}
    </div>
  </section>;
};
